import {
  ScriptDefinition,
  isScriptDefinition
} from "@common-core/react-composable/script-injector";
import {VisibleItem} from "../visibility";

export interface EmbeddedComponent extends VisibleItem {
  id: string;
  script: ScriptDefinition;
  element: string;
  attributes?: Record<string, any>;
  preload?: boolean;
}

export function isEmbeddedComponent(arg: any): arg is EmbeddedComponent {
  return (
    arg !== null &&
    arg !== undefined &&
    arg.script !== null &&
    isScriptDefinition(arg.script) &&
    typeof arg.id === "string" &&
    typeof arg.element === "string" &&
    (!("attributes" in arg) || typeof arg.attributes === "object") &&
    (!("preload" in arg) || typeof arg.preload === "boolean")
  );
}
